export const pagesPath = {
  '$404': {
    $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/404' as const, hash: url?.hash })
  },
  _legacyPath: (legacyPath: string[]) => ({
    $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/[...legacyPath]' as const, query: { legacyPath }, hash: url?.hash })
  }),
  'debug': {
    'auth': {
      $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/debug/auth' as const, hash: url?.hash })
    }
  },
  'oauth': {
    'torqee': {
      'callback': {
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/oauth/torqee/callback' as const, hash: url?.hash })
      }
    },
    'zoom': {
      'callback': {
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/oauth/zoom/callback' as const, hash: url?.hash })
      }
    }
  },
  'w': {
    _workspaceId: (workspaceId: string | number) => ({
      'apps': {
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/apps' as const, query: { workspaceId }, hash: url?.hash })
      },
      'connections': {
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/connections' as const, query: { workspaceId }, hash: url?.hash })
      },
      'home': {
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/home' as const, query: { workspaceId }, hash: url?.hash })
      },
      'members': {
        _id: (id: string | number) => ({
          'edit': {
            $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/members/[id]/edit' as const, query: { workspaceId, id }, hash: url?.hash })
          }
        }),
        'add': {
          $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/members/add' as const, query: { workspaceId }, hash: url?.hash })
        },
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/members' as const, query: { workspaceId }, hash: url?.hash })
      },
      'notifications': {
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/notifications' as const, query: { workspaceId }, hash: url?.hash })
      },
      'oauth': {
        'torqee': {
          'callback': {
            $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/oauth/torqee/callback' as const, query: { workspaceId }, hash: url?.hash })
          }
        },
        'zoom': {
          'callback': {
            $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/oauth/zoom/callback' as const, query: { workspaceId }, hash: url?.hash })
          }
        }
      },
      'phone_numbers': {
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/phone-numbers' as const, query: { workspaceId }, hash: url?.hash })
      },
      'shop_staffs': {
        _id: (id: string | number) => ({
          'edit': {
            $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/shop-staffs/[id]/edit' as const, query: { workspaceId, id }, hash: url?.hash })
          }
        }),
        'add': {
          $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/shop-staffs/add' as const, query: { workspaceId }, hash: url?.hash })
        },
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/shop-staffs' as const, query: { workspaceId }, hash: url?.hash })
      },
      'support': {
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/support' as const, query: { workspaceId }, hash: url?.hash })
      },
      'webhooks': {
        _id: (id: string | number) => ({
          'edit': {
            $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/webhooks/[id]/edit' as const, query: { workspaceId, id }, hash: url?.hash })
          },
          $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/webhooks/[id]' as const, query: { workspaceId, id }, hash: url?.hash })
        }),
        'add': {
          $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/webhooks/add' as const, query: { workspaceId }, hash: url?.hash })
        },
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/webhooks' as const, query: { workspaceId }, hash: url?.hash })
      },
      $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]' as const, query: { workspaceId }, hash: url?.hash })
    })
  },
  $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/' as const, hash: url?.hash })
};

export type PagesPath = typeof pagesPath;

export const staticPath = {
  apple_touch_icon_png: '/apple-touch-icon.png',
  circles_svg: '/circles.svg',
  favicon_ico: '/favicon.ico',
  icon_192_png: '/icon-192.png',
  icon_512_png: '/icon-512.png',
  icon_svg: '/icon.svg',
  manifest_json: '/manifest.json'
} as const;

export type StaticPath = typeof staticPath;
